/**
 * The venue photograph, and the space kept for it.
 *
 * `foto` is optional in the catalogue and null on every venue so far. Nothing
 * here invents one: stock imagery and frames grabbed from the broadcasts are
 * both out. The list cards and the venue card both leave the picture out
 * entirely until a real photograph exists.
 */

import { el } from './format.js';

const LABELS = { card: 'foto', hero: 'foto del locale' };

export function venuePhoto(venue, variant) {
  const box = el('div', `shot shot--${variant}`);

  if (venue.foto) {
    const image = el('img');
    image.src = venue.foto;
    // Decorative next to the name it belongs to: an empty alt keeps a screen
    // reader from announcing the venue twice.
    image.alt = '';
    image.loading = 'lazy';
    box.append(image);
    return box;
  }

  box.append(el('small', null, LABELS[variant]));
  return box;
}
